import { useAppContext } from '@/Main';
import { changeBgColor } from '@/utils/pre-load/changeBgColor';

/**
 * Shimmer block with the same outer height as the chart or grid it replaces.
 * Height is set on a block box so line-height cannot add extra pixels.
 */
const PlotSkeleton = ({ height }: { height: number | string }) => {
  const {
    config: { theme }
  } = useAppContext() as { config: { theme: string } };

  return (
    <>
      <div
        className="text_chart_loading d-block"
        style={{ height, width: '100%' }}
        aria-hidden
      />
      <style>
        {`
          .text_chart_loading{
            background:${changeBgColor(theme)};
            background-size: 200% 100%;
            background-position: 100% 0;
          }
        `}
      </style>
    </>
  );
};

export default PlotSkeleton;
